import { useState, useCallback } from 'react';

export const useParticipantChat = () => {
  const [chatOpen, setChatOpen] = useState(false);
  const [activeParticipantEmail, setActiveParticipantEmail] = useState<
    string | undefined
  >(undefined);

  const handleChatOpen = useCallback((email: string) => {
    setActiveParticipantEmail(email);
    setChatOpen(true);
  }, []);

  const handleChatToggle = useCallback(() => {
    setChatOpen((prevChatOpen) => {
      const nextChatOpen = !prevChatOpen;
      if (!nextChatOpen) {
        setActiveParticipantEmail(undefined);
      }
      return nextChatOpen;
    });
  }, []);

  return {
    chatOpen,
    activeParticipantEmail,
    handleChatOpen,
    handleChatToggle,
  };
};
